import { Action } from 'redux';
import { ActionType } from '../../actions-types';

export type infoAccount = {
  // id: number;
  name: string;

  managerName: string;
  phoneNumber: number;
  password: string;
  email: string;
  countryName: string;
  specialCargoStorage: string;
  scaleArea: number;
  scaleAreaUnit: string;
  websiteUrl: string;
  majorStorageProduct: [];
  lng: string;
  lat: string;
  detailAddress: string;
  googleMapAddress: string;
  country: string;
  postalCode: string;
  description: string;
  countryCode: string;
  businessLicense: number;
  images: [];
};

interface infoListAccount {
  dataInfo: infoAccount[] | any;
}

const initialInfo: infoListAccount = { dataInfo: [] };

const myAccountReducerReducer = (
  state: infoListAccount = initialInfo,
  action: Action
): infoListAccount => {
  switch (action.type) {
    case ActionType.GET_INFORMATION_ACCOUNT:
      return {
        ...initialInfo,
        dataInfo: []
      };
    default:
      return state;
  }
};

export default myAccountReducerReducer;
